
export function createCPMObject(num) {
  return {
    label: num,
    value: num,
    name: `$${num} CPM`
  };
}

export function generateCPMArray(min, max) {
  let result = [];

  for (let i = min; i <= max; i++) {
    result.push({
      label: i,
      value: i,
      name: `$${i} CPM`
    });
  }

  return result;
}
export const PREMIUM_CPM = generateCPMArray(20, 50)

export const SUPPORT_OPTIONS = [
  {
    "label": "Standard Package - Free",
    "value": "Standard Package - Free"
  },
  {
    "label": "Foundation Package - $10,000/month",
    "value": "Foundation Package - $10,000/month"
  },
  {
    "label": "Growth Package - $15,000/month",
    "value": "Growth Package - $15,000/month"
  },
  {
    "label": "Elite Package - $20,000/month",
    "value": "Elite Package - $20,000/month"
  }
]

export const MONTHLY_SPEND_BAND = [
  {
    "label": "$50,000 - $100,000",
    "value": "$50,000 - $100,000",
    "min": 50000,
    "max": 100000,
    "country": "AU"
  },
  {
    "label": "$100,000 - $150,000",
    "value": "$100,000 - $150,000",
    "min": 100001,
    "max": 150000,
    "country": "AU"
  },
  {
    "label": "$150,000 - $200,000",
    "value": "$150,000 - $200,000",
    "min": 150001,
    "max": 200000,
    "country": "AU"
  },
  {
    "label": "$200,000 - $250,000",
    "value": "$200,000 - $250,000",
    "min": 200001,
    "max": 250000,
    "country": "AU"
  },
  {
    "label": "$250,000 - $300,000",
    "value": "$250,000 - $300,000",
    "min": 250001,
    "max": 300000,
    "country": "AU"
  },
  {
    "label": "$300,000 +",
    "value": "$300,000 +",
    "min": 300001,
    "max": 10000000,
    "country": "AU"
  },

  {
    "label": "$20,000 - $40,000",
    "value": "$20,000 - $40,000",
    "min": 20000,
    "max": 40000,
    "country": "NZ"
  },
  {
    "label": "$40,000 - $60,000",
    "value": "$40,000 - $60,000",
    "min": 40001,
    "max": 60000,
    "country": "NZ"
  },
  {
    "label": "$60,000 - $80,000",
    "value": "$60,000 - $80,000",
    "min": 60001,
    "max": 80000,
    "country": "NZ"
  },
  {
    "label": "$80,000 - $100,000",
    "value": "$80,000 - $100,000",
    "min": 80001,
    "max": 100000,
    "country": "NZ"
  },
  {
    "label": "$100,000+",
    "value": "$100,000+",
    "min": 100001,
    "max": 10000000,
    "country": "NZ"
  }


]

export const APEXEstimateData = [
  {
    "billing_month": "Jan",
    "apex_earnings": "$16,800"
  },
  {
    "billing_month": "Feb",
    "apex_earnings": "$21,000"
  },
  {
    "billing_month": "Mar",
    "apex_earnings": "$41,800"
  },
  {
    "billing_month": "Apr",
    "apex_earnings": "$38,000"
  },
  {
    "billing_month": "May",
    "apex_earnings": "$41,800"
  },
  {
    "billing_month": "Jun",
    "apex_earnings": "$58,800"
  },
  {
    "billing_month": "Jul",
    "apex_earnings": "$31,500"
  },
  {
    "billing_month": "Aug",
    "apex_earnings": "$35,000"
  },
  {
    "billing_month": "Sep",
    "apex_earnings": "$41,800"
  },
  {
    "billing_month": "Oct",
    "apex_earnings": "$35,000"
  },
  {
    "billing_month": "Nov",
    "apex_earnings": "$43,700"
  },
  {
    "billing_month": "Dec",
    "apex_earnings": "$31,500"
  }
]

export const APEXTableData = [
  {
    "Index": 1,
    "commercialModel": "independent",
    "start period": "2025-01-01",
    "end period": "2025-01-31",
    "billing month": "2025-01",
    "totalSpend": "110,000",
    "premiumComposition": "57.00%",
    "premiumSpend": "62,700",
    "advancedSpend": "47,300",
    "premiumCPM": 22,
    "advancedCPM": 26,
    "premiumImps": "2,850,000",
    "advancedImps": "1,819,231",
    "premiumPercentage": "25.80%",
    "advancedPercentage": "25.40%",
    "premiumFee": "16,177",
    "advancedFee": "12,014",
    "totalFee": "28,191",
    "totalPercentage": "25.63%",
    "clientPercentage": "74.37%",
    "valueAfterFee": "81,809",
    "statementNumber": "BIG-100236",
    "invoiceNumber": "BIG-81278271",
    "impIncreased": "",
    "supportFee": "10,000",
    "totalFeeWithSupport": "41,081",
    "country": "AU"
  },
  {
    "Index": 2,
    "commercialModel": "independent",
    "start period": "2025-02-01",
    "end period": "2025-02-28",
    "billing month": "2025-02",
    "totalSpend": "130,000",
    "premiumComposition": "59.00%",
    "premiumSpend": "76,700",
    "advancedSpend": "53,300",
    "premiumCPM": 22,
    "advancedCPM": 26,
    "premiumImps": "3,486,364",
    "advancedImps": "2,050,000",
    "premiumPercentage": "25.80%",
    "advancedPercentage": "25.40%",
    "premiumFee": "19,789",
    "advancedFee": "13,538",
    "totalFee": "33,327",
    "totalPercentage": "25.64%",
    "clientPercentage": "74.36%",
    "valueAfterFee": "96,673",
    "statementNumber": "BIG-100237",
    "invoiceNumber": "BIG-81278272",
    "impIncreased": "",
    "country": "AU"
  },
  {
    "Index": 3,
    "commercialModel": "independent",
    "start period": "2025-03-01",
    "end period": "2025-03-31",
    "billing month": "2025-03",
    "totalSpend": "95,000",
    "premiumComposition": "40.00%",
    "premiumSpend": "38,000",
    "advancedSpend": "57,000",
    "premiumCPM": 22,
    "advancedCPM": 26,
    "premiumImps": "1,727,273",
    "advancedImps": "2,192,308",
    "premiumPercentage": "27.80%",
    "advancedPercentage": "27.40%",
    "premiumFee": "10,564",
    "advancedFee": "15,618",
    "totalFee": "26,182",
    "totalPercentage": "27.56%",
    "clientPercentage": "72.44%",
    "valueAfterFee": "68,818",
    "statementNumber": "BIG-100238",
    "invoiceNumber": "BIG-81278273",
    "impIncreased": "",
    "country": "AU"
  },
  {
    "Index": 4,
    "commercialModel": "independent",
    "start period": "2025-04-01",
    "end period": "2025-04-30",
    "billing month": "2025-04",
    "totalSpend": "105,000",
    "premiumComposition": "71.00%",
    "premiumSpend": "74,550",
    "advancedSpend": "30,450",
    "premiumCPM": 22,
    "advancedCPM": 26,
    "premiumImps": "3,388,636",
    "advancedImps": "1,171,154",
    "premiumPercentage": "25.80%",
    "advancedPercentage": "25.40%",
    "premiumFee": "19,234",
    "advancedFee": "7,734",
    "totalFee": "26,968",
    "totalPercentage": "25.68%",
    "clientPercentage": "74.32%",
    "valueAfterFee": "78,032",
    "statementNumber": "BIG-100239",
    "invoiceNumber": "BIG-81278274",
    "impIncreased": "",
    "country": "AU"
  },
  {
    "Index": 5,
    "commercialModel": "independent",
    "start period": "2025-05-01",
    "end period": "2025-05-31",
    "billing month": "2025-05",
    "totalSpend": "125,000",
    "premiumComposition": "73.00%",
    "premiumSpend": "91,250",
    "advancedSpend": "33,750",
    "premiumCPM": 22,
    "advancedCPM": 26,
    "premiumImps": "4,147,727",
    "advancedImps": "1,298,077",
    "premiumPercentage": "25.80%",
    "advancedPercentage": "25.40%",
    "premiumFee": "23,543",
    "advancedFee": "8,573",
    "totalFee": "32,115",
    "totalPercentage": "25.69%",
    "clientPercentage": "74.31%",
    "valueAfterFee": "92,885",
    "statementNumber": "BIG-100240",
    "invoiceNumber": "BIG-81278275",
    "impIncreased": "",
    "country": "AU"
  },
  {
    "Index": 6,
    "commercialModel": "independent",
    "start period": "2025-06-01",
    "end period": "2025-06-30",
    "billing month": "2025-06",
    "totalSpend": "195,000",
    "premiumComposition": "78.00%",
    "premiumSpend": "152,100",
    "advancedSpend": "42,900",
    "premiumCPM": 22,
    "advancedCPM": 26,
    "premiumImps": "6,913,636",
    "advancedImps": "1,650,000",
    "premiumPercentage": "24.80%",
    "advancedPercentage": "24.40%",
    "premiumFee": "37,721",
    "advancedFee": "10,468",
    "totalFee": "48,188",
    "totalPercentage": "24.71%",
    "clientPercentage": "75.29%",
    "valueAfterFee": "146,812",
    "statementNumber": "BIG-100241",
    "invoiceNumber": "BIG-81278276",
    "impIncreased": "",
    "country": "AU"
  },
  {
    "Index": 7,
    "commercialModel": "independent",
    "start period": "2025-07-01",
    "end period": "2025-07-31",
    "billing month": "2025-07",
    "totalSpend": "99,000",
    "premiumComposition": "66.00%",
    "premiumSpend": "65,340",
    "advancedSpend": "33,660",
    "premiumCPM": 22,
    "advancedCPM": 26,
    "premiumImps": "2,970,000",
    "advancedImps": "1,294,615",
    "premiumPercentage": "27.80%",
    "advancedPercentage": "27.40%",
    "premiumFee": "18,165",
    "advancedFee": "9,223",
    "totalFee": "27,387",
    "totalPercentage": "27.66%",
    "clientPercentage": "72.34%",
    "valueAfterFee": "71,613",
    "statementNumber": "BIG-100242",
    "invoiceNumber": "BIG-81278277",
    "impIncreased": "",
    "country": "AU"
  },
  {
    "Index": 8,
    "commercialModel": "independent",
    "start period": "2025-08-01",
    "end period": "2025-08-31",
    "billing month": "2025-08",
    "totalSpend": "112,000",
    "premiumComposition": "44.00%",
    "premiumSpend": "49,280",
    "advancedSpend": "62,720",
    "premiumCPM": 22,
    "advancedCPM": 26,
    "premiumImps": "2,240,000",
    "advancedImps": "2,412,308",
    "premiumPercentage": "25.80%",
    "advancedPercentage": "25.40%",
    "premiumFee": "12,714",
    "advancedFee": "15,931",
    "totalFee": "28,645",
    "totalPercentage": "25.58%",
    "clientPercentage": "74.42%",
    "valueAfterFee": "83,355",
    "statementNumber": "BIG-100243",
    "invoiceNumber": "BIG-81278278",
    "impIncreased": "",
    "country": "AU"
  },
  {
    "Index": 9,
    "commercialModel": "independent",
    "start period": "2025-09-01",
    "end period": "2025-09-30",
    "billing month": "2025-09",
    "totalSpend": "121,000",
    "premiumComposition": "49.00%",
    "premiumSpend": "59,290",
    "advancedSpend": "61,710",
    "premiumCPM": 22,
    "advancedCPM": 26,
    "premiumImps": "2,695,000",
    "advancedImps": "2,373,462",
    "premiumPercentage": "25.80%",
    "advancedPercentage": "25.40%",
    "premiumFee": "15,297",
    "advancedFee": "15,674",
    "totalFee": "30,971",
    "totalPercentage": "25.60%",
    "clientPercentage": "74.40%",
    "valueAfterFee": "90,029",
    "statementNumber": "BIG-100244",
    "invoiceNumber": "BIG-81278279",
    "impIncreased": "",
    "country": "AU"
  },
  {
    "Index": 10,
    "commercialModel": "independent",
    "start period": "2025-10-01",
    "end period": "2025-10-31",
    "billing month": "2025-10",
    "totalSpend": "141,000",
    "premiumComposition": "47.00%",
    "premiumSpend": "66,270",
    "advancedSpend": "74,730",
    "premiumCPM": 22,
    "advancedCPM": 26,
    "premiumImps": "3,012,273",
    "advancedImps": "2,874,231",
    "premiumPercentage": "25.80%",
    "advancedPercentage": "25.40%",
    "premiumFee": "17,098",
    "advancedFee": "18,981",
    "totalFee": "36,079",
    "totalPercentage": "25.59%",
    "clientPercentage": "74.41%",
    "valueAfterFee": "104,921",
    "statementNumber": "BIG-100245",
    "invoiceNumber": "BIG-81278280",
    "impIncreased": "",
    "country": "AU"
  },
  {
    "Index": 11,
    "commercialModel": "independent",
    "start period": "2025-11-01",
    "end period": "2025-11-30",
    "billing month": "2025-11",
    "totalSpend": "210,000",
    "premiumComposition": "50.00%",
    "premiumSpend": "105,000",
    "advancedSpend": "105,000",
    "premiumCPM": 22,
    "advancedCPM": 26,
    "premiumImps": "4,772,727",
    "advancedImps": "4,038,462",
    "premiumPercentage": "23.80%",
    "advancedPercentage": "23.40%",
    "premiumFee": "24,990",
    "advancedFee": "24,570",
    "totalFee": "49,560",
    "totalPercentage": "23.60%",
    "clientPercentage": "76.40%",
    "valueAfterFee": "160,440",
    "statementNumber": "BIG-100246",
    "invoiceNumber": "BIG-81278281",
    "impIncreased": "",
    "country": "AU"
  },
  {
    "Index": 12,
    "commercialModel": "independent",
    "start period": "2025-12-01",
    "end period": "2025-12-31",
    "billing month": "2025-12",
    "totalSpend": "101,000",
    "premiumComposition": "49.00%",
    "premiumSpend": "49,490",
    "advancedSpend": "51,510",
    "premiumCPM": 22,
    "advancedCPM": 26,
    "premiumImps": "2,249,545",
    "advancedImps": "1,981,154",
    "premiumPercentage": "25.80%",
    "advancedPercentage": "25.40%",
    "premiumFee": "12,768",
    "advancedFee": "13,084",
    "totalFee": "25,852",
    "totalPercentage": "25.60%",
    "clientPercentage": "74.40%",
    "valueAfterFee": "75,148",
    "statementNumber": "BIG-100247",
    "invoiceNumber": "BIG-81278282",
    "impIncreased": "",
    "country": "AU"
  },
  {
    "Index": 49,
    "commercialModel": "unified - rewards",
    "start period": "2025-01-01",
    "end period": "2025-01-31",
    "billing month": "2025-01",
    "totalSpend": "110,000",
    "premiumComposition": "57.00%",
    "premiumSpend": "62,700",
    "advancedSpend": "47,300",
    "premiumCPM": 22,
    "advancedCPM": 26,
    "premiumImps": "2,850,000",
    "advancedImps": "1,819,231",
    "premiumPercentage": "8.33%",
    "advancedPercentage": "9.09%",
    "premiumFee": "15,675",
    "advancedFee": "10,915",
    "totalFee": "28,700",
    "totalPercentage": "25.00%",
    "clientPercentage": "23.08%",
    "valueAfterFee": "24.17%",
    "statementNumber": "BIG-100248",
    "invoiceNumber": "BIG-81278283",
    "impIncreased": "",
    "country": "AU"
  },
  {
    "Index": 50,
    "commercialModel": "unified - rewards",
    "start period": "2025-02-01",
    "end period": "2025-02-28",
    "billing month": "2025-02",
    "totalSpend": "130,000",
    "premiumComposition": "59.00%",
    "premiumSpend": "76,700",
    "advancedSpend": "53,300",
    "premiumCPM": 22,
    "advancedCPM": 26,
    "premiumImps": "3,486,364",
    "advancedImps": "2,050,000",
    "premiumPercentage": "8.33%",
    "advancedPercentage": "9.09%",
    "premiumFee": "19,175",
    "advancedFee": "12,300",
    "totalFee": "31,475",
    "totalPercentage": "25.00%",
    "clientPercentage": "23.08%",
    "valueAfterFee": "24.21%",
    "statementNumber": "BIG-100249",
    "invoiceNumber": "BIG-81278284",
    "impIncreased": "",
    "country": "AU"
  },
  {
    "Index": 51,
    "commercialModel": "unified - rewards",
    "start period": "2025-03-01",
    "end period": "2025-03-31",
    "billing month": "2025-03",
    "totalSpend": "95,000",
    "premiumComposition": "40.00%",
    "premiumSpend": "38,000",
    "advancedSpend": "57,000",
    "premiumCPM": 22,
    "advancedCPM": 26,
    "premiumImps": "1,727,273",
    "advancedImps": "2,192,308",
    "premiumPercentage": "5.56%",
    "advancedPercentage": "6.82%",
    "premiumFee": "8,636",
    "advancedFee": "12,058",
    "totalFee": "20,694",
    "totalPercentage": "22.73%",
    "clientPercentage": "21.15%",
    "valueAfterFee": "21.78%",
    "statementNumber": "BIG-100250",
    "invoiceNumber": "BIG-81278285",
    "impIncreased": "",
    "country": "AU"
  },
  {
    "Index": 52,
    "commercialModel": "unified - rewards",
    "start period": "2025-04-01",
    "end period": "2025-04-30",
    "billing month": "2025-04",
    "totalSpend": "105,000",
    "premiumComposition": "71.00%",
    "premiumSpend": "74,550",
    "advancedSpend": "30,450",
    "premiumCPM": 22,
    "advancedCPM": 26,
    "premiumImps": "3,388,636",
    "advancedImps": "1,171,154",
    "premiumPercentage": "8.33%",
    "advancedPercentage": "9.09%",
    "premiumFee": "18,638",
    "advancedFee": "7,027",
    "totalFee": "25,664",
    "totalPercentage": "25.00%",
    "clientPercentage": "23.08%",
    "valueAfterFee": "24.44%",
    "statementNumber": "BIG-100251",
    "invoiceNumber": "BIG-81278286",
    "impIncreased": "",
    "country": "AU"
  },
  {
    "Index": 53,
    "commercialModel": "unified - rewards",
    "start period": "2025-05-01",
    "end period": "2025-05-31",
    "billing month": "2025-05",
    "totalSpend": "125,000",
    "premiumComposition": "73.00%",
    "premiumSpend": "91,250",
    "advancedSpend": "33,750",
    "premiumCPM": 22,
    "advancedCPM": 26,
    "premiumImps": "4,147,727",
    "advancedImps": "1,298,077",
    "premiumPercentage": "8.33%",
    "advancedPercentage": "9.09%",
    "premiumFee": "22,813",
    "advancedFee": "7,788",
    "totalFee": "30,601",
    "totalPercentage": "25.00%",
    "clientPercentage": "23.08%",
    "valueAfterFee": "24.48%",
    "statementNumber": "BIG-100252",
    "invoiceNumber": "BIG-81278287",
    "impIncreased": "",
    "country": "AU"
  },
  {
    "Index": 54,
    "commercialModel": "unified - rewards",
    "start period": "2025-06-01",
    "end period": "2025-06-30",
    "billing month": "2025-06",
    "totalSpend": "195,000",
    "premiumComposition": "78.00%",
    "premiumSpend": "152,100",
    "advancedSpend": "42,900",
    "premiumCPM": 22,
    "advancedCPM": 26,
    "premiumImps": "6,913,636",
    "advancedImps": "1,650,000",
    "premiumPercentage": "11.11%",
    "advancedPercentage": "11.36%",
    "premiumFee": "41,482",
    "advancedFee": "10,725",
    "totalFee": "52,207",
    "totalPercentage": "27.27%",
    "clientPercentage": "25.00%",
    "valueAfterFee": "26.77%",
    "statementNumber": "BIG-100253",
    "invoiceNumber": "BIG-81278288",
    "impIncreased": "",
    "country": "AU"
  },
  {
    "Index": 55,
    "commercialModel": "unified - rewards",
    "start period": "2025-07-01",
    "end period": "2025-07-31",
    "billing month": "2025-07",
    "totalSpend": "99,000",
    "premiumComposition": "66.00%",
    "premiumSpend": "65,340",
    "advancedSpend": "33,660",
    "premiumCPM": 22,
    "advancedCPM": 26,
    "premiumImps": "2,970,000",
    "advancedImps": "1,294,615",
    "premiumPercentage": "5.56%",
    "advancedPercentage": "6.82%",
    "premiumFee": "14,850",
    "advancedFee": "7,120",
    "totalFee": "21,970",
    "totalPercentage": "22.73%",
    "clientPercentage": "21.15%",
    "valueAfterFee": "22.19%",
    "statementNumber": "BIG-100254",
    "invoiceNumber": "BIG-81278289",
    "impIncreased": "",
    "country": "AU"
  },
  {
    "Index": 56,
    "commercialModel": "unified - rewards",
    "start period": "2025-08-01",
    "end period": "2025-08-31",
    "billing month": "2025-08",
    "totalSpend": "112,000",
    "premiumComposition": "44.00%",
    "premiumSpend": "49,280",
    "advancedSpend": "62,720",
    "premiumCPM": 22,
    "advancedCPM": 26,
    "premiumImps": "2,240,000",
    "advancedImps": "2,412,308",
    "premiumPercentage": "8.33%",
    "advancedPercentage": "9.09%",
    "premiumFee": "12,320",
    "advancedFee": "14,474",
    "totalFee": "26,794",
    "totalPercentage": "25.00%",
    "clientPercentage": "23.08%",
    "valueAfterFee": "23.92%",
    "statementNumber": "BIG-100255",
    "invoiceNumber": "BIG-81278290",
    "impIncreased": "",
    "country": "AU"
  },
  {
    "Index": 57,
    "commercialModel": "unified - rewards",
    "start period": "2025-09-01",
    "end period": "2025-09-30",
    "billing month": "2025-09",
    "totalSpend": "121,000",
    "premiumComposition": "49.00%",
    "premiumSpend": "59,290",
    "advancedSpend": "61,710",
    "premiumCPM": 22,
    "advancedCPM": 26,
    "premiumImps": "2,695,000",
    "advancedImps": "2,373,462",
    "premiumPercentage": "8.33%",
    "advancedPercentage": "9.09%",
    "premiumFee": "14,823",
    "advancedFee": "14,241",
    "totalFee": "29,063",
    "totalPercentage": "25.00%",
    "clientPercentage": "23.08%",
    "valueAfterFee": "24.02%",
    "statementNumber": "BIG-100256",
    "invoiceNumber": "BIG-81278291",
    "impIncreased": "",
    "country": "AU"
  },
  {
    "Index": 58,
    "commercialModel": "unified - rewards",
    "start period": "2025-10-01",
    "end period": "2025-10-31",
    "billing month": "2025-10",
    "totalSpend": "141,000",
    "premiumComposition": "47.00%",
    "premiumSpend": "66,270",
    "advancedSpend": "74,730",
    "premiumCPM": 22,
    "advancedCPM": 26,
    "premiumImps": "3,012,273",
    "advancedImps": "2,874,231",
    "premiumPercentage": "8.33%",
    "advancedPercentage": "9.09%",
    "premiumFee": "16,568",
    "advancedFee": "17,245",
    "totalFee": "33,813",
    "totalPercentage": "25.00%",
    "clientPercentage": "23.08%",
    "valueAfterFee": "23.98%",
    "statementNumber": "BIG-100257",
    "invoiceNumber": "BIG-81278292",
    "impIncreased": "",
    "country": "AU"
  },
  {
    "Index": 59,
    "commercialModel": "unified - rewards",
    "start period": "2025-11-01",
    "end period": "2025-11-30",
    "billing month": "2025-11",
    "totalSpend": "210,000",
    "premiumComposition": "50.00%",
    "premiumSpend": "105,000",
    "advancedSpend": "105,000",
    "premiumCPM": 22,
    "advancedCPM": 26,
    "premiumImps": "4,772,727",
    "advancedImps": "4,038,462",
    "premiumPercentage": "13.89%",
    "advancedPercentage": "13.64%",
    "premiumFee": "31,023",
    "advancedFee": "28,269",
    "totalFee": "59,292",
    "totalPercentage": "29.55%",
    "clientPercentage": "26.92%",
    "valueAfterFee": "28.23%",
    "statementNumber": "BIG-100258",
    "invoiceNumber": "BIG-81278293",
    "impIncreased": "",
    "country": "AU"
  },
  {
    "Index": 60,
    "commercialModel": "unified - rewards",
    "start period": "2025-12-01",
    "end period": "2025-12-31",
    "billing month": "2025-12",
    "totalSpend": "101,000",
    "premiumComposition": "49.00%",
    "premiumSpend": "49,490",
    "advancedSpend": "51,510",
    "premiumCPM": 22,
    "advancedCPM": 26,
    "premiumImps": "2,249,545",
    "advancedImps": "1,981,154",
    "premiumPercentage": "8.33%",
    "advancedPercentage": "9.09%",
    "premiumFee": "12,373",
    "advancedFee": "11,887",
    "totalFee": "24,259",
    "totalPercentage": "25.00%",
    "clientPercentage": "23.08%",
    "valueAfterFee": "24.02%",
    "statementNumber": "BIG-100259",
    "invoiceNumber": "BIG-81278294",
    "impIncreased": "",
    "country": "AU"
  },

  {
    "Index": 25,
    "commercialModel": "unified - discount",
    "start period": "2025-01-01",
    "end period": "2025-01-31",
    "billing month": "2025-01",
    "totalSpend": "110,000",
    "premiumComposition": "57.00%",
    "premiumSpend": "62,700",
    "advancedSpend": "47,300",
    "premiumCPM": 18,
    "advancedCPM": 22,
    "premiumImps": "3,483,333",
    "advancedImps": "2,150,000",
    "premiumPercentage": "16.67%",
    "advancedPercentage": "15.91%",
    "premiumFee": "10,452",
    "advancedFee": "7,525",
    "totalFee": "14,723",
    "totalPercentage": "16.34%",
    "clientPercentage": "83.66%",
    "valueAfterFee": "92,022",
    "statementNumber": "BIG-100260",
    "invoiceNumber": "BIG-81278295",
    "impIncreased": "1,319,374",
    "country": "AU"
  },
  {
    "Index": 26,
    "commercialModel": "unified - discount",
    "start period": "2025-02-01",
    "end period": "2025-02-28",
    "billing month": "2025-02",
    "totalSpend": "130,000",
    "premiumComposition": "59.00%",
    "premiumSpend": "76,700",
    "advancedSpend": "53,300",
    "premiumCPM": 18,
    "advancedCPM": 22,
    "premiumImps": "4,261,111",
    "advancedImps": "2,422,727",
    "premiumPercentage": "16.67%",
    "advancedPercentage": "15.91%",
    "premiumFee": "12,786",
    "advancedFee": "8,480",
    "totalFee": "21,266",
    "totalPercentage": "16.36%",
    "clientPercentage": "83.64%",
    "valueAfterFee": "108,734",
    "statementNumber": "BIG-100261",
    "invoiceNumber": "BIG-81278296",
    "impIncreased": "1,310,812",
    "country": "AU"
  },
  {
    "Index": 27,
    "commercialModel": "unified - discount",
    "start period": "2025-03-01",
    "end period": "2025-03-31",
    "billing month": "2025-03",
    "totalSpend": "95,000",
    "premiumComposition": "40.00%",
    "premiumSpend": "38,000",
    "advancedSpend": "57,000",
    "premiumCPM": 18,
    "advancedCPM": 22,
    "premiumImps": "2,111,111",
    "advancedImps": "2,590,909",
    "premiumPercentage": "11.11%",
    "advancedPercentage": "11.36%",
    "premiumFee": "4,222",
    "advancedFee": "6,270",
    "totalFee": "10,492",
    "totalPercentage": "11.04%",
    "clientPercentage": "88.96%",
    "valueAfterFee": "84,508",
    "statementNumber": "BIG-100262",
    "invoiceNumber": "BIG-81278297",
    "impIncreased": "584,084",
    "country": "AU"
  },
  {
    "Index": 28,
    "commercialModel": "unified - discount",
    "start period": "2025-04-01",
    "end period": "2025-04-30",
    "billing month": "2025-04",
    "totalSpend": "105,000",
    "premiumComposition": "71.00%",
    "premiumSpend": "74,550",
    "advancedSpend": "30,450",
    "premiumCPM": 18,
    "advancedCPM": 22,
    "premiumImps": "4,141,667",
    "advancedImps": "1,384,091",
    "premiumPercentage": "16.67%",
    "advancedPercentage": "15.91%",
    "premiumFee": "12,427",
    "advancedFee": "4,845",
    "totalFee": "17,272",
    "totalPercentage": "16.45%",
    "clientPercentage": "83.55%",
    "valueAfterFee": "87,728",
    "statementNumber": "BIG-100263",
    "invoiceNumber": "BIG-81278298",
    "impIncreased": "1,090,405",
    "country": "AU"
  },
  {
    "Index": 29,
    "commercialModel": "unified - discount",
    "start period": "2025-05-01",
    "end period": "2025-05-31",
    "billing month": "2025-05",
    "totalSpend": "125,000",
    "premiumComposition": "73.00%",
    "premiumSpend": "91,250",
    "advancedSpend": "33,750",
    "premiumCPM": 18,
    "advancedCPM": 22,
    "premiumImps": "5,069,444",
    "advancedImps": "1,534,091",
    "premiumPercentage": "16.67%",
    "advancedPercentage": "15.91%",
    "premiumFee": "15,211",
    "advancedFee": "5,370",
    "totalFee": "20,581",
    "totalPercentage": "16.46%",
    "clientPercentage": "83.54%",
    "valueAfterFee": "104,419",
    "statementNumber": "BIG-100264",
    "invoiceNumber": "BIG-81278299",
    "impIncreased": "1,304,385",
    "country": "AU"
  },
  {
    "Index": 30,
    "commercialModel": "unified - discount",
    "start period": "2025-06-01",
    "end period": "2025-06-30",
    "billing month": "2025-06",
    "totalSpend": "195,000",
    "premiumComposition": "78.00%",
    "premiumSpend": "152,100",
    "advancedSpend": "42,900",
    "premiumCPM": 18,
    "advancedCPM": 22,
    "premiumImps": "8,450,000",
    "advancedImps": "1,950,000",
    "premiumPercentage": "19.44%",
    "advancedPercentage": "18.18%",
    "premiumFee": "29,568",
    "advancedFee": "7,799",
    "totalFee": "37,367",
    "totalPercentage": "19.16%",
    "clientPercentage": "80.84%",
    "valueAfterFee": "157,633",
    "statementNumber": "BIG-100265",
    "invoiceNumber": "BIG-81278300",
    "impIncreased": "2,472,357",
    "country": "AU"
  },
  {
    "Index": 31,
    "commercialModel": "unified - discount",
    "start period": "2025-07-01",
    "end period": "2025-07-31",
    "billing month": "2025-07",
    "totalSpend": "99,000",
    "premiumComposition": "66.00%",
    "premiumSpend": "65,340",
    "advancedSpend": "33,660",
    "premiumCPM": 18,
    "advancedCPM": 22,
    "premiumImps": "3,630,000",
    "advancedImps": "1,530,000",
    "premiumPercentage": "11.11%",
    "advancedPercentage": "11.36%",
    "premiumFee": "7,259",
    "advancedFee": "3,703",
    "totalFee": "10,962",
    "totalPercentage": "11.07%",
    "clientPercentage": "88.93%",
    "valueAfterFee": "88,038",
    "statementNumber": "BIG-100266",
    "invoiceNumber": "BIG-81278301",
    "impIncreased": "642,800",
    "country": "AU"
  },
  {
    "Index": 32,
    "commercialModel": "unified - discount",
    "start period": "2025-08-01",
    "end period": "2025-08-31",
    "billing month": "2025-08",
    "totalSpend": "112,000",
    "premiumComposition": "44.00%",
    "premiumSpend": "49,280",
    "advancedSpend": "62,720",
    "premiumCPM": 18,
    "advancedCPM": 22,
    "premiumImps": "2,737,778",
    "advancedImps": "2,850,909",
    "premiumPercentage": "16.67%",
    "advancedPercentage": "15.91%",
    "premiumFee": "8,215",
    "advancedFee": "9,979",
    "totalFee": "18,194",
    "totalPercentage": "16.24%",
    "clientPercentage": "83.76%",
    "valueAfterFee": "93,806",
    "statementNumber": "BIG-100267",
    "invoiceNumber": "BIG-81278302",
    "impIncreased": "1,087,085",
    "country": "AU"
  },
  {
    "Index": 33,
    "commercialModel": "unified - discount",
    "start period": "2025-09-01",
    "end period": "2025-09-30",
    "billing month": "2025-09",
    "totalSpend": "121,000",
    "premiumComposition": "49.00%",
    "premiumSpend": "59,290",
    "advancedSpend": "61,710",
    "premiumCPM": 18,
    "advancedCPM": 22,
    "premiumImps": "3,293,889",
    "advancedImps": "2,805,000",
    "premiumPercentage": "16.67%",
    "advancedPercentage": "15.91%",
    "premiumFee": "9,884",
    "advancedFee": "9,818",
    "totalFee": "19,702",
    "totalPercentage": "16.28%",
    "clientPercentage": "83.72%",
    "valueAfterFee": "101,298",
    "statementNumber": "BIG-100268",
    "invoiceNumber": "BIG-81278303",
    "impIncreased": "1,189,648",
    "country": "AU"
  },
  {
    "Index": 34,
    "commercialModel": "unified - discount",
    "start period": "2025-10-01",
    "end period": "2025-10-31",
    "billing month": "2025-10",
    "totalSpend": "141,000",
    "premiumComposition": "47.00%",
    "premiumSpend": "66,270",
    "advancedSpend": "74,730",
    "premiumCPM": 18,
    "advancedCPM": 22,
    "premiumImps": "3,681,667",
    "advancedImps": "3,396,818",
    "premiumPercentage": "16.67%",
    "advancedPercentage": "15.91%",
    "premiumFee": "11,047",
    "advancedFee": "11,890",
    "totalFee": "22,937",
    "totalPercentage": "16.27%",
    "clientPercentage": "83.73%",
    "valueAfterFee": "118,063",
    "statementNumber": "BIG-100269",
    "invoiceNumber": "BIG-81278304",
    "impIncreased": "1,379,195",
    "country": "AU"
  },
  {
    "Index": 35,
    "commercialModel": "unified - discount",
    "start period": "2025-11-01",
    "end period": "2025-11-30",
    "billing month": "2025-11",
    "totalSpend": "210,000",
    "premiumComposition": "50.00%",
    "premiumSpend": "105,000",
    "advancedSpend": "105,000",
    "premiumCPM": 18,
    "advancedCPM": 22,
    "premiumImps": "5,833,333",
    "advancedImps": "4,772,727",
    "premiumPercentage": "22.22%",
    "advancedPercentage": "20.45%",
    "premiumFee": "23,331",
    "advancedFee": "21,473",
    "totalFee": "44,804",
    "totalPercentage": "21.34%",
    "clientPercentage": "78.67%",
    "valueAfterFee": "165,197",
    "statementNumber": "BIG-100270",
    "invoiceNumber": "BIG-81278305",
    "impIncreased": "2,893,382",
    "country": "AU"
  },
  {
    "Index": 36,
    "commercialModel": "unified - discount",
    "start period": "2025-12-01",
    "end period": "2025-12-31",
    "billing month": "2025-12",
    "totalSpend": "101,000",
    "premiumComposition": "49.00%",
    "premiumSpend": "49,490",
    "advancedSpend": "51,510",
    "premiumCPM": 18,
    "advancedCPM": 22,
    "premiumImps": "2,749,444",
    "advancedImps": "2,341,364",
    "premiumPercentage": "16.67%",
    "advancedPercentage": "15.91%",
    "premiumFee": "8,250",
    "advancedFee": "8,195",
    "totalFee": "16,445",
    "totalPercentage": "16.28%",
    "clientPercentage": "83.72%",
    "valueAfterFee": "84,555",
    "statementNumber": "BIG-100271",
    "invoiceNumber": "BIG-81278306",
    "impIncreased": "993,012",
    "country": "AU"
  },
  {
    "Index": 37,
    "commercialModel": "unified - margin",
    "start period": "2025-01-01",
    "end period": "2025-01-31",
    "billing month": "2025-01",
    "totalSpend": "185,388",
    "premiumComposition": "58.63%",
    "premiumSpend": "108,684",
    "advancedSpend": "76,704",
    "premiumCPM": 15,
    "advancedCPM": 18.5,
    "premiumImps": "4,180,167",
    "advancedImps": "2,556,784",
    "premiumPercentage": "73.34%",
    "advancedPercentage": "62.16%",
    "premiumFee": "45,984",
    "advancedFee": "29,404",
    "totalFee": "60,208",
    "totalPercentage": "",
    "clientPercentage": "",
    "valueAfterFee": "",
    "statementNumber": "BIG-100272",
    "invoiceNumber": "BIG-81278307",
    "impIncreased": "",
    "country": "AU"
  },
  {
    "Index": 38,
    "commercialModel": "unified - margin",
    "start period": "2025-02-01",
    "end period": "2025-02-28",
    "billing month": "2025-02",
    "totalSpend": "219,385",
    "premiumComposition": "60.60%",
    "premiumSpend": "132,952",
    "advancedSpend": "86,433",
    "premiumCPM": 15,
    "advancedCPM": 18.5,
    "premiumImps": "5,113,538",
    "advancedImps": "2,881,112",
    "premiumPercentage": "73.34%",
    "advancedPercentage": "62.16%",
    "premiumFee": "56,252",
    "advancedFee": "33,133",
    "totalFee": "89,385",
    "totalPercentage": "",
    "clientPercentage": "",
    "valueAfterFee": "",
    "statementNumber": "BIG-100273",
    "invoiceNumber": "BIG-81278308",
    "impIncreased": "",
    "country": "AU"
  },
  {
    "Index": 39,
    "commercialModel": "unified - margin",
    "start period": "2025-03-01",
    "end period": "2025-03-31",
    "billing month": "2025-03",
    "totalSpend": "149,083",
    "premiumComposition": "41.42%",
    "premiumSpend": "61,749",
    "advancedSpend": "87,334",
    "premiumCPM": 16,
    "advancedCPM": 19.58,
    "premiumImps": "2,374,970",
    "advancedImps": "2,911,134",
    "premiumPercentage": "62.50%",
    "advancedPercentage": "53.22%",
    "premiumFee": "23,749",
    "advancedFee": "30,334",
    "totalFee": "54,083",
    "totalPercentage": "",
    "clientPercentage": "",
    "valueAfterFee": "",
    "statementNumber": "BIG-100274",
    "invoiceNumber": "BIG-81278309",
    "impIncreased": "",
    "country": "AU"
  },
  {
    "Index": 40,
    "commercialModel": "unified - margin",
    "start period": "2025-04-01",
    "end period": "2025-04-30",
    "billing month": "2025-04",
    "totalSpend": "178,604",
    "premiumComposition": "72.35%",
    "premiumSpend": "129,225",
    "advancedSpend": "49,379",
    "premiumCPM": 15,
    "advancedCPM": 18.5,
    "premiumImps": "4,970,199",
    "advancedImps": "1,645,964",
    "premiumPercentage": "73.34%",
    "advancedPercentage": "62.16%",
    "premiumFee": "54,675",
    "advancedFee": "18,929",
    "totalFee": "73,604",
    "totalPercentage": "",
    "clientPercentage": "",
    "valueAfterFee": "",
    "statementNumber": "BIG-100275",
    "invoiceNumber": "BIG-81278310",
    "impIncreased": "",
    "country": "AU"
  },
  {
    "Index": 41,
    "commercialModel": "unified - margin",
    "start period": "2025-05-01",
    "end period": "2025-05-31",
    "billing month": "2025-05",
    "totalSpend": "212,903",
    "premiumComposition": "74.29%",
    "premiumSpend": "158,173",
    "advancedSpend": "54,730",
    "premiumCPM": 15,
    "advancedCPM": 18.5,
    "premiumImps": "6,083,577",
    "advancedImps": "1,824,344",
    "premiumPercentage": "73.34%",
    "advancedPercentage": "62.16%",
    "premiumFee": "66,923",
    "advancedFee": "20,980",
    "totalFee": "87,903",
    "totalPercentage": "",
    "clientPercentage": "",
    "valueAfterFee": "",
    "statementNumber": "BIG-100276",
    "invoiceNumber": "BIG-81278311",
    "impIncreased": "",
    "country": "AU"
  },
  {
    "Index": 42,
    "commercialModel": "unified - margin",
    "start period": "2025-06-01",
    "end period": "2025-06-30",
    "billing month": "2025-06",
    "totalSpend": "344,214",
    "premiumComposition": "79.23%",
    "premiumSpend": "272,716",
    "advancedSpend": "71,498",
    "premiumCPM": 14.5,
    "advancedCPM": 18,
    "premiumImps": "10,489,076",
    "advancedImps": "2,383,280",
    "premiumPercentage": "79.30%",
    "advancedPercentage": "66.66%",
    "premiumFee": "120,616",
    "advancedFee": "28,598",
    "totalFee": "149,214",
    "totalPercentage": "",
    "clientPercentage": "",
    "valueAfterFee": "",
    "statementNumber": "BIG-100277",
    "invoiceNumber": "BIG-81278312",
    "impIncreased": "",
    "country": "AU"
  },
  {
    "Index": 43,
    "commercialModel": "unified - margin",
    "start period": "2025-07-01",
    "end period": "2025-07-31",
    "billing month": "2025-07",
    "totalSpend": "157,749",
    "premiumComposition": "67.31%",
    "premiumSpend": "106,176",
    "advancedSpend": "51,573",
    "premiumCPM": 16,
    "advancedCPM": 19.58,
    "premiumImps": "4,083,699",
    "advancedImps": "1,719,101",
    "premiumPercentage": "62.50%",
    "advancedPercentage": "53.22%",
    "premiumFee": "40,836",
    "advancedFee": "17,913",
    "totalFee": "58,749",
    "totalPercentage": "",
    "clientPercentage": "",
    "valueAfterFee": "",
    "statementNumber": "BIG-100278",
    "invoiceNumber": "BIG-81278313",
    "impIncreased": "",
    "country": "AU"
  },
  {
    "Index": 44,
    "commercialModel": "unified - margin",
    "start period": "2025-08-01",
    "end period": "2025-08-31",
    "billing month": "2025-08",
    "totalSpend": "187,131",
    "premiumComposition": "45.65%",
    "premiumSpend": "85,422",
    "advancedSpend": "101,709",
    "premiumCPM": 15,
    "advancedCPM": 18.5,
    "premiumImps": "3,285,465",
    "advancedImps": "3,390,307",
    "premiumPercentage": "73.34%",
    "advancedPercentage": "62.16%",
    "premiumFee": "36,142",
    "advancedFee": "38,989",
    "totalFee": "75,131",
    "totalPercentage": "",
    "clientPercentage": "",
    "valueAfterFee": "",
    "statementNumber": "BIG-100279",
    "invoiceNumber": "BIG-81278314",
    "impIncreased": "",
    "country": "AU"
  },
  {
    "Index": 45,
    "commercialModel": "unified - margin",
    "start period": "2025-09-01",
    "end period": "2025-09-30",
    "billing month": "2025-09",
    "totalSpend": "202,845",
    "premiumComposition": "50.67%",
    "premiumSpend": "102,773",
    "advancedSpend": "100,071",
    "premiumCPM": 15,
    "advancedCPM": 18.5,
    "premiumImps": "3,952,825",
    "advancedImps": "3,335,712",
    "premiumPercentage": "73.34%",
    "advancedPercentage": "62.16%",
    "premiumFee": "43,483",
    "advancedFee": "38,361",
    "totalFee": "81,845",
    "totalPercentage": "",
    "clientPercentage": "",
    "valueAfterFee": "",
    "statementNumber": "BIG-100280",
    "invoiceNumber": "BIG-81278315",
    "impIncreased": "",
    "country": "AU"
  },
  {
    "Index": 46,
    "commercialModel": "unified - margin",
    "start period": "2025-10-01",
    "end period": "2025-10-31",
    "billing month": "2025-10",
    "totalSpend": "236,058",
    "premiumComposition": "48.66%",
    "premiumSpend": "114,873",
    "advancedSpend": "121,185",
    "premiumCPM": 15,
    "advancedCPM": 18.5,
    "premiumImps": "4,418,177",
    "advancedImps": "4,039,503",
    "premiumPercentage": "73.34%",
    "advancedPercentage": "62.16%",
    "premiumFee": "48,603",
    "advancedFee": "46,455",
    "totalFee": "95,058",
    "totalPercentage": "",
    "clientPercentage": "",
    "valueAfterFee": "",
    "statementNumber": "BIG-100281",
    "invoiceNumber": "BIG-81278316",
    "impIncreased": "",
    "country": "AU"
  },
  {
    "Index": 47,
    "commercialModel": "unified - margin",
    "start period": "2025-11-01",
    "end period": "2025-11-30",
    "billing month": "2025-11",
    "totalSpend": "374,984",
    "premiumComposition": "52.00%",
    "premiumSpend": "194,994",
    "advancedSpend": "179,990",
    "premiumCPM": 14,
    "advancedCPM": 17.5,
    "premiumImps": "7,499,786",
    "advancedImps": "5,999,657",
    "premiumPercentage": "85.71%",
    "advancedPercentage": "71.42%",
    "premiumFee": "89,994",
    "advancedFee": "74,990",
    "totalFee": "164,984",
    "totalPercentage": "",
    "clientPercentage": "",
    "valueAfterFee": "",
    "statementNumber": "BIG-100282",
    "invoiceNumber": "BIG-81278317",
    "impIncreased": "",
    "country": "AU"
  },
  {
    "Index": 48,
    "commercialModel": "unified - margin",
    "start period": "2025-12-01",
    "end period": "2025-12-31",
    "billing month": "2025-12",
    "totalSpend": "169,317",
    "premiumComposition": "50.67%",
    "premiumSpend": "85,786",
    "advancedSpend": "83,531",
    "premiumCPM": 15,
    "advancedCPM": 18.5,
    "premiumImps": "3,299,465",
    "advancedImps": "2,784,354",
    "premiumPercentage": "73.34%",
    "advancedPercentage": "62.16%",
    "premiumFee": "36,296",
    "advancedFee": "32,021",
    "totalFee": "68,317",
    "totalPercentage": "",
    "clientPercentage": "",
    "valueAfterFee": "",
    "statementNumber": "BIG-100283",
    "invoiceNumber": "BIG-81278318",
    "impIncreased": "",
    "country": "AU"
  },
  {
    "Index": 61,
    "commercialModel": "independent",
    "start period": "2025-01-01",
    "end period": "2025-01-31",
    "billing month": "2025-01",
    "totalSpend": "22,000",
    "premiumComposition": "57.00%",
    "premiumSpend": "12,540",
    "advancedSpend": "9,460",
    "premiumCPM": 18,
    "advancedCPM": 21,
    "premiumImps": "696,667",
    "advancedImps": "450,476",
    "premiumPercentage": "27.70%",
    "advancedPercentage": "27.40%",
    "premiumFee": "3,474",
    "advancedFee": "2,592",
    "totalFee": "6,066",
    "totalPercentage": "27.57%",
    "clientPercentage": "72.43%",
    "valueAfterFee": "15,934",
    "statementNumber": "BIG-200236",
    "invoiceNumber": "BIG-91278271",
    "impIncreased": "",
    "country": "NZ",
    "supportFee": "10,000",
    "totalFeeWithSupport": "16,066",
  },
  {
    "Index": 62,
    "commercialModel": "independent",
    "start period": "2025-02-01",
    "end period": "2025-02-28",
    "billing month": "2025-02",
    "totalSpend": "24,000",
    "premiumComposition": "59.00%",
    "premiumSpend": "14,160",
    "advancedSpend": "9,840",
    "premiumCPM": 18,
    "advancedCPM": 21,
    "premiumImps": "786,667",
    "advancedImps": "468,571",
    "premiumPercentage": "27.70%",
    "advancedPercentage": "27.40%",
    "premiumFee": "3,922",
    "advancedFee": "2,696",
    "totalFee": "6,618",
    "totalPercentage": "27.58%",
    "clientPercentage": "72.42%",
    "valueAfterFee": "17,382",
    "statementNumber": "BIG-200237",
    "invoiceNumber": "BIG-91278272",
    "impIncreased": "",
    "country": "NZ"
  },
  {
    "Index": 63,
    "commercialModel": "independent",
    "start period": "2025-03-01",
    "end period": "2025-03-31",
    "billing month": "2025-03",
    "totalSpend": "35,000",
    "premiumComposition": "40.00%",
    "premiumSpend": "14,000",
    "advancedSpend": "21,000",
    "premiumCPM": 18,
    "advancedCPM": 21,
    "premiumImps": "777,778",
    "advancedImps": "1,000,000",
    "premiumPercentage": "27.70%",
    "advancedPercentage": "27.40%",
    "premiumFee": "3,878",
    "advancedFee": "5,754",
    "totalFee": "9,632",
    "totalPercentage": "27.52%",
    "clientPercentage": "72.48%",
    "valueAfterFee": "25,368",
    "statementNumber": "BIG-200238",
    "invoiceNumber": "BIG-91278273",
    "impIncreased": "",
    "country": "NZ"
  },
  {
    "Index": 64,
    "commercialModel": "independent",
    "start period": "2025-04-01",
    "end period": "2025-04-30",
    "billing month": "2025-04",
    "totalSpend": "31,000",
    "premiumComposition": "71.00%",
    "premiumSpend": "22,010",
    "advancedSpend": "8,990",
    "premiumCPM": 18,
    "advancedCPM": 21,
    "premiumImps": "1,222,778",
    "advancedImps": "428,095",
    "premiumPercentage": "27.70%",
    "advancedPercentage": "27.40%",
    "premiumFee": "6,097",
    "advancedFee": "2,463",
    "totalFee": "8,560",
    "totalPercentage": "27.61%",
    "clientPercentage": "72.39%",
    "valueAfterFee": "22,440",
    "statementNumber": "BIG-200239",
    "invoiceNumber": "BIG-91278274",
    "impIncreased": "",
    "country": "NZ"
  },
  {
    "Index": 65,
    "commercialModel": "independent",
    "start period": "2025-05-01",
    "end period": "2025-05-31",
    "billing month": "2025-05",
    "totalSpend": "49,000",
    "premiumComposition": "73.00%",
    "premiumSpend": "35,770",
    "advancedSpend": "13,230",
    "premiumCPM": 18,
    "advancedCPM": 21,
    "premiumImps": "1,987,222",
    "advancedImps": "630,000",
    "premiumPercentage": "25.70%",
    "advancedPercentage": "25.40%",
    "premiumFee": "9,193",
    "advancedFee": "3,360",
    "totalFee": "12,553",
    "totalPercentage": "25.62%",
    "clientPercentage": "74.38%",
    "valueAfterFee": "36,447",
    "statementNumber": "BIG-200240",
    "invoiceNumber": "BIG-91278275",
    "impIncreased": "",
    "country": "NZ"
  },
  {
    "Index": 66,
    "commercialModel": "independent",
    "start period": "2025-06-01",
    "end period": "2025-06-30",
    "billing month": "2025-06",
    "totalSpend": "58,000",
    "premiumComposition": "78.00%",
    "premiumSpend": "45,240",
    "advancedSpend": "12,760",
    "premiumCPM": 18,
    "advancedCPM": 21,
    "premiumImps": "2,513,333",
    "advancedImps": "607,619",
    "premiumPercentage": "25.70%",
    "advancedPercentage": "25.40%",
    "premiumFee": "11,627",
    "advancedFee": "3,241",
    "totalFee": "14,868",
    "totalPercentage": "25.63%",
    "clientPercentage": "74.37%",
    "valueAfterFee": "43,132",
    "statementNumber": "BIG-200241",
    "invoiceNumber": "BIG-91278276",
    "impIncreased": "",
    "country": "NZ"
  },
  {
    "Index": 67,
    "commercialModel": "independent",
    "start period": "2025-07-01",
    "end period": "2025-07-31",
    "billing month": "2025-07",
    "totalSpend": "26,000",
    "premiumComposition": "66.00%",
    "premiumSpend": "17,160",
    "advancedSpend": "8,840",
    "premiumCPM": 18,
    "advancedCPM": 21,
    "premiumImps": "953,333",
    "advancedImps": "420,952",
    "premiumPercentage": "27.70%",
    "advancedPercentage": "27.40%",
    "premiumFee": "4,753",
    "advancedFee": "2,422",
    "totalFee": "7,175",
    "totalPercentage": "27.60%",
    "clientPercentage": "72.40%",
    "valueAfterFee": "18,825",
    "statementNumber": "BIG-200242",
    "invoiceNumber": "BIG-91278277",
    "impIncreased": "",
    "country": "NZ"
  },
  {
    "Index": 68,
    "commercialModel": "independent",
    "start period": "2025-08-01",
    "end period": "2025-08-31",
    "billing month": "2025-08",
    "totalSpend": "22,000",
    "premiumComposition": "44.00%",
    "premiumSpend": "9,680",
    "advancedSpend": "12,320",
    "premiumCPM": 18,
    "advancedCPM": 21,
    "premiumImps": "537,778",
    "advancedImps": "586,667",
    "premiumPercentage": "27.70%",
    "advancedPercentage": "27.40%",
    "premiumFee": "2,681",
    "advancedFee": "3,376",
    "totalFee": "6,057",
    "totalPercentage": "27.53%",
    "clientPercentage": "72.47%",
    "valueAfterFee": "15,943",
    "statementNumber": "BIG-200243",
    "invoiceNumber": "BIG-91278278",
    "impIncreased": "",
    "country": "NZ"
  },
  {
    "Index": 69,
    "commercialModel": "independent",
    "start period": "2025-09-01",
    "end period": "2025-09-30",
    "billing month": "2025-09",
    "totalSpend": "37,000",
    "premiumComposition": "49.00%",
    "premiumSpend": "18,130",
    "advancedSpend": "18,870",
    "premiumCPM": 18,
    "advancedCPM": 21,
    "premiumImps": "1,007,222",
    "advancedImps": "898,571",
    "premiumPercentage": "27.70%",
    "advancedPercentage": "27.40%",
    "premiumFee": "5,022",
    "advancedFee": "5,170",
    "totalFee": "10,192",
    "totalPercentage": "27.55%",
    "clientPercentage": "72.45%",
    "valueAfterFee": "26,808",
    "statementNumber": "BIG-200244",
    "invoiceNumber": "BIG-91278279",
    "impIncreased": "",
    "country": "NZ"
  },
  {
    "Index": 70,
    "commercialModel": "independent",
    "start period": "2025-10-01",
    "end period": "2025-10-31",
    "billing month": "2025-10",
    "totalSpend": "31,000",
    "premiumComposition": "47.00%",
    "premiumSpend": "14,570",
    "advancedSpend": "16,430",
    "premiumCPM": 18,
    "advancedCPM": 21,
    "premiumImps": "809,444",
    "advancedImps": "782,381",
    "premiumPercentage": "27.70%",
    "advancedPercentage": "27.40%",
    "premiumFee": "4,036",
    "advancedFee": "4,502",
    "totalFee": "8,538",
    "totalPercentage": "27.54%",
    "clientPercentage": "72.46%",
    "valueAfterFee": "22,462",
    "statementNumber": "BIG-200245",
    "invoiceNumber": "BIG-91278280",
    "impIncreased": "",
    "country": "NZ"
  },
  {
    "Index": 71,
    "commercialModel": "independent",
    "start period": "2025-11-01",
    "end period": "2025-11-30",
    "billing month": "2025-11",
    "totalSpend": "65,000",
    "premiumComposition": "50.00%",
    "premiumSpend": "32,500",
    "advancedSpend": "32,500",
    "premiumCPM": 18,
    "advancedCPM": 21,
    "premiumImps": "1,805,556",
    "advancedImps": "1,547,619",
    "premiumPercentage": "24.70%",
    "advancedPercentage": "24.40%",
    "premiumFee": "8,028",
    "advancedFee": "7,930",
    "totalFee": "15,958",
    "totalPercentage": "24.55%",
    "clientPercentage": "75.45%",
    "valueAfterFee": "49,043",
    "statementNumber": "BIG-200246",
    "invoiceNumber": "BIG-91278281",
    "impIncreased": "",
    "country": "NZ"
  },
  {
    "Index": 72,
    "commercialModel": "independent",
    "start period": "2025-12-01",
    "end period": "2025-12-31",
    "billing month": "2025-12",
    "totalSpend": "28,000",
    "premiumComposition": "49.00%",
    "premiumSpend": "13,720",
    "advancedSpend": "14,280",
    "premiumCPM": 18,
    "advancedCPM": 21,
    "premiumImps": "762,222",
    "advancedImps": "680,000",
    "premiumPercentage": "27.70%",
    "advancedPercentage": "27.40%",
    "premiumFee": "3,800",
    "advancedFee": "3,913",
    "totalFee": "7,713",
    "totalPercentage": "27.55%",
    "clientPercentage": "72.45%",
    "valueAfterFee": "20,287",
    "statementNumber": "BIG-200247",
    "invoiceNumber": "BIG-91278282",
    "impIncreased": "",
    "country": "NZ"
  },
  {
    "Index": 73,
    "commercialModel": "unified - discount",
    "start period": "2025-01-01",
    "end period": "2025-01-31",
    "billing month": "2025-01",
    "totalSpend": "22,000",
    "premiumComposition": "57.00%",
    "premiumSpend": "12,540",
    "advancedSpend": "9,460",
    "premiumCPM": 15,
    "advancedCPM": 17,
    "premiumImps": "836,000",
    "advancedImps": "556,471",
    "premiumPercentage": "16.67%",
    "advancedPercentage": "14.71%",
    "premiumFee": "2,090",
    "advancedFee": "1,392",
    "totalFee": "3,482",
    "totalPercentage": "15.83%",
    "clientPercentage": "84.17%",
    "valueAfterFee": "18,518",
    "statementNumber": "BIG-200248",
    "invoiceNumber": "BIG-91278283",
    "impIncreased": "167,240",
    "country": "NZ"
  },
  {
    "Index": 74,
    "commercialModel": "unified - discount",
    "start period": "2025-02-01",
    "end period": "2025-02-28",
    "billing month": "2025-02",
    "totalSpend": "24,000",
    "premiumComposition": "59.00%",
    "premiumSpend": "14,160",
    "advancedSpend": "9,840",
    "premiumCPM": 15,
    "advancedCPM": 17,
    "premiumImps": "944,000",
    "advancedImps": "578,824",
    "premiumPercentage": "16.67%",
    "advancedPercentage": "14.71%",
    "premiumFee": "2,360",
    "advancedFee": "1,447",
    "totalFee": "3,808",
    "totalPercentage": "15.87%",
    "clientPercentage": "84.13%",
    "valueAfterFee": "20,192",
    "statementNumber": "BIG-200249",
    "invoiceNumber": "BIG-91278284",
    "impIncreased": "188,845",
    "country": "NZ"
  },
  {
    "Index": 75,
    "commercialModel": "unified - discount",
    "start period": "2025-03-01",
    "end period": "2025-03-31",
    "billing month": "2025-03",
    "totalSpend": "35,000",
    "premiumComposition": "40.00%",
    "premiumSpend": "14,000",
    "advancedSpend": "21,000",
    "premiumCPM": 15,
    "advancedCPM": 17,
    "premiumImps": "933,333",
    "advancedImps": "1,235,294",
    "premiumPercentage": "16.67%",
    "advancedPercentage": "14.71%",
    "premiumFee": "2,334",
    "advancedFee": "3,089",
    "totalFee": "5,423",
    "totalPercentage": "15.49%",
    "clientPercentage": "84.51%",
    "valueAfterFee": "29,577",
    "statementNumber": "BIG-200250",
    "invoiceNumber": "BIG-91278285",
    "impIncreased": "186,711",
    "country": "NZ"
  },
  {
    "Index": 76,
    "commercialModel": "unified - discount",
    "start period": "2025-04-01",
    "end period": "2025-04-30",
    "billing month": "2025-04",
    "totalSpend": "31,000",
    "premiumComposition": "71.00%",
    "premiumSpend": "22,010",
    "advancedSpend": "8,990",
    "premiumCPM": 15,
    "advancedCPM": 17,
    "premiumImps": "1,467,333",
    "advancedImps": "528,824",
    "premiumPercentage": "16.67%",
    "advancedPercentage": "14.71%",
    "premiumFee": "3,669",
    "advancedFee": "1,322",
    "totalFee": "4,991",
    "totalPercentage": "16.10%",
    "clientPercentage": "83.90%",
    "valueAfterFee": "26,009",
    "statementNumber": "BIG-200251",
    "invoiceNumber": "BIG-91278286",
    "impIncreased": "293,537",
    "country": "NZ"
  },
  {
    "Index": 77,
    "commercialModel": "unified - discount",
    "start period": "2025-05-01",
    "end period": "2025-05-31",
    "billing month": "2025-05",
    "totalSpend": "49,000",
    "premiumComposition": "73.00%",
    "premiumSpend": "35,770",
    "advancedSpend": "13,230",
    "premiumCPM": 15,
    "advancedCPM": 17,
    "premiumImps": "2,384,667",
    "advancedImps": "778,235",
    "premiumPercentage": "20.00%",
    "advancedPercentage": "17.65%",
    "premiumFee": "7,154",
    "advancedFee": "2,335",
    "totalFee": "9,489",
    "totalPercentage": "19.37%",
    "clientPercentage": "80.63%",
    "valueAfterFee": "39,511",
    "statementNumber": "BIG-200252",
    "invoiceNumber": "BIG-91278287",
    "impIncreased": "596,167",
    "country": "NZ"
  },
  {
    "Index": 78,
    "commercialModel": "unified - discount",
    "start period": "2025-06-01",
    "end period": "2025-06-30",
    "billing month": "2025-06",
    "totalSpend": "58,000",
    "premiumComposition": "78.00%",
    "premiumSpend": "45,240",
    "advancedSpend": "12,760",
    "premiumCPM": 15,
    "advancedCPM": 17,
    "premiumImps": "3,016,000",
    "advancedImps": "750,588",
    "premiumPercentage": "20.00%",
    "advancedPercentage": "17.65%",
    "premiumFee": "9,048",
    "advancedFee": "2,252",
    "totalFee": "11,300",
    "totalPercentage": "19.48%",
    "clientPercentage": "80.52%",
    "valueAfterFee": "46,700",
    "statementNumber": "BIG-200253",
    "invoiceNumber": "BIG-91278288",
    "impIncreased": "754,000",
    "country": "NZ"
  },
  {
    "Index": 79,
    "commercialModel": "unified - discount",
    "start period": "2025-07-01",
    "end period": "2025-07-31",
    "billing month": "2025-07",
    "totalSpend": "26,000",
    "premiumComposition": "66.00%",
    "premiumSpend": "17,160",
    "advancedSpend": "8,840",
    "premiumCPM": 15,
    "advancedCPM": 17,
    "premiumImps": "1,144,000",
    "advancedImps": "520,000",
    "premiumPercentage": "16.67%",
    "advancedPercentage": "14.71%",
    "premiumFee": "2,861",
    "advancedFee": "1,300",
    "totalFee": "4,161",
    "totalPercentage": "16.00%",
    "clientPercentage": "84.00%",
    "valueAfterFee": "21,839",
    "statementNumber": "BIG-200254",
    "invoiceNumber": "BIG-91278289",
    "impIncreased": "228,855",
    "country": "NZ"
  },
  {
    "Index": 80,
    "commercialModel": "unified - discount",
    "start period": "2025-08-01",
    "end period": "2025-08-31",
    "billing month": "2025-08",
    "totalSpend": "22,000",
    "premiumComposition": "44.00%",
    "premiumSpend": "9,680",
    "advancedSpend": "12,320",
    "premiumCPM": 15,
    "advancedCPM": 17,
    "premiumImps": "645,333",
    "advancedImps": "724,706",
    "premiumPercentage": "16.67%",
    "advancedPercentage": "14.71%",
    "premiumFee": "1,614",
    "advancedFee": "1,812",
    "totalFee": "3,426",
    "totalPercentage": "15.57%",
    "clientPercentage": "84.43%",
    "valueAfterFee": "18,574",
    "statementNumber": "BIG-200255",
    "invoiceNumber": "BIG-91278290",
    "impIncreased": "129,098",
    "country": "NZ"
  },
  {
    "Index": 81,
    "commercialModel": "unified - discount",
    "start period": "2025-09-01",
    "end period": "2025-09-30",
    "billing month": "2025-09",
    "totalSpend": "37,000",
    "premiumComposition": "49.00%",
    "premiumSpend": "18,130",
    "advancedSpend": "18,870",
    "premiumCPM": 15,
    "advancedCPM": 17,
    "premiumImps": "1,208,667",
    "advancedImps": "1,110,000",
    "premiumPercentage": "16.67%",
    "advancedPercentage": "14.71%",
    "premiumFee": "3,022",
    "advancedFee": "2,776",
    "totalFee": "5,798",
    "totalPercentage": "15.67%",
    "clientPercentage": "84.33%",
    "valueAfterFee": "31,202",
    "statementNumber": "BIG-200256",
    "invoiceNumber": "BIG-91278291",
    "impIncreased": "241,791",
    "country": "NZ"
  },
  {
    "Index": 82,
    "commercialModel": "unified - discount",
    "start period": "2025-10-01",
    "end period": "2025-10-31",
    "billing month": "2025-10",
    "totalSpend": "31,000",
    "premiumComposition": "47.00%",
    "premiumSpend": "14,570",
    "advancedSpend": "16,430",
    "premiumCPM": 15,
    "advancedCPM": 17,
    "premiumImps": "971,333",
    "advancedImps": "966,471",
    "premiumPercentage": "16.67%",
    "advancedPercentage": "14.71%",
    "premiumFee": "2,429",
    "advancedFee": "2,417",
    "totalFee": "4,846",
    "totalPercentage": "15.63%",
    "clientPercentage": "84.37%",
    "valueAfterFee": "26,154",
    "statementNumber": "BIG-200257",
    "invoiceNumber": "BIG-91278292",
    "impIncreased": "194,313",
    "country": "NZ"
  },
  {
    "Index": 83,
    "commercialModel": "unified - discount",
    "start period": "2025-11-01",
    "end period": "2025-11-30",
    "billing month": "2025-11",
    "totalSpend": "65,000",
    "premiumComposition": "50.00%",
    "premiumSpend": "32,500",
    "advancedSpend": "32,500",
    "premiumCPM": 15,
    "advancedCPM": 17,
    "premiumImps": "2,166,667",
    "advancedImps": "1,911,765",
    "premiumPercentage": "23.33%",
    "advancedPercentage": "20.59%",
    "premiumFee": "7,582",
    "advancedFee": "6,692",
    "totalFee": "14,274",
    "totalPercentage": "21.96%",
    "clientPercentage": "78.04%",
    "valueAfterFee": "50,726",
    "statementNumber": "BIG-200258",
    "invoiceNumber": "BIG-91278293",
    "impIncreased": "659,297",
    "country": "NZ"
  },
  {
    "Index": 84,
    "commercialModel": "unified - discount",
    "start period": "2025-12-01",
    "end period": "2025-12-31",
    "billing month": "2025-12",
    "totalSpend": "28,000",
    "premiumComposition": "49.00%",
    "premiumSpend": "13,720",
    "advancedSpend": "14,280",
    "premiumCPM": 15,
    "advancedCPM": 17,
    "premiumImps": "914,667",
    "advancedImps": "840,000",
    "premiumPercentage": "16.67%",
    "advancedPercentage": "14.71%",
    "premiumFee": "2,287",
    "advancedFee": "2,101",
    "totalFee": "4,388",
    "totalPercentage": "15.67%",
    "clientPercentage": "84.33%",
    "valueAfterFee": "23,612",
    "statementNumber": "BIG-200259",
    "invoiceNumber": "BIG-91278294",
    "impIncreased": "182,977",
    "country": "NZ"
  },
  {
    "Index": 85,
    "commercialModel": "unified - rewards",
    "start period": "2025-01-01",
    "end period": "2025-01-31",
    "billing month": "2025-01",
    "totalSpend": "22,000",
    "premiumComposition": "57.00%",
    "premiumSpend": "12,540",
    "advancedSpend": "9,460",
    "premiumCPM": 18,
    "advancedCPM": 21,
    "premiumImps": "696,667",
    "advancedImps": "450,476",
    "premiumPercentage": "16.67%",
    "advancedPercentage": "14.71%",
    "premiumFee": "3,832",
    "advancedFee": "2,928",
    "totalFee": "6,760",
    "totalPercentage": "30.56%",
    "clientPercentage": "30.96%",
    "valueAfterFee": "30.73%",
    "statementNumber": "BIG-200260",
    "invoiceNumber": "BIG-91278295",
    "impIncreased": "",
    "country": "NZ"
  },
  {
    "Index": 86,
    "commercialModel": "unified - rewards",
    "start period": "2025-02-01",
    "end period": "2025-02-28",
    "billing month": "2025-02",
    "totalSpend": "24,000",
    "premiumComposition": "59.00%",
    "premiumSpend": "14,160",
    "advancedSpend": "9,840",
    "premiumCPM": 18,
    "advancedCPM": 21,
    "premiumImps": "786,667",
    "advancedImps": "468,571",
    "premiumPercentage": "16.67%",
    "advancedPercentage": "14.71%",
    "premiumFee": "4,327",
    "advancedFee": "3,046",
    "totalFee": "7,373",
    "totalPercentage": "30.56%",
    "clientPercentage": "30.96%",
    "valueAfterFee": "30.72%",
    "statementNumber": "BIG-200261",
    "invoiceNumber": "BIG-91278296",
    "impIncreased": "",
    "country": "NZ"
  },
  {
    "Index": 87,
    "commercialModel": "unified - rewards",
    "start period": "2025-03-01",
    "end period": "2025-03-31",
    "billing month": "2025-03",
    "totalSpend": "35,000",
    "premiumComposition": "40.00%",
    "premiumSpend": "14,000",
    "advancedSpend": "21,000",
    "premiumCPM": 18,
    "advancedCPM": 21,
    "premiumImps": "777,778",
    "advancedImps": "1,000,000",
    "premiumPercentage": "16.67%",
    "advancedPercentage": "14.71%",
    "premiumFee": "4,278",
    "advancedFee": "6,501",
    "totalFee": "10,779",
    "totalPercentage": "30.56%",
    "clientPercentage": "30.96%",
    "valueAfterFee": "30.80%",
    "statementNumber": "BIG-200262",
    "invoiceNumber": "BIG-91278297",
    "impIncreased": "",
    "country": "NZ"
  },
  {
    "Index": 88,
    "commercialModel": "unified - rewards",
    "start period": "2025-04-01",
    "end period": "2025-04-30",
    "billing month": "2025-04",
    "totalSpend": "31,000",
    "premiumComposition": "71.00%",
    "premiumSpend": "22,010",
    "advancedSpend": "8,990",
    "premiumCPM": 18,
    "advancedCPM": 21,
    "premiumImps": "1,222,778",
    "advancedImps": "428,095",
    "premiumPercentage": "16.67%",
    "advancedPercentage": "14.71%",
    "premiumFee": "6,726",
    "advancedFee": "2,783",
    "totalFee": "9,509",
    "totalPercentage": "30.56%",
    "clientPercentage": "30.96%",
    "valueAfterFee": "30.67%",
    "statementNumber": "BIG-200263",
    "invoiceNumber": "BIG-91278298",
    "impIncreased": "",
    "country": "NZ"
  },
  {
    "Index": 89,
    "commercialModel": "unified - rewards",
    "start period": "2025-05-01",
    "end period": "2025-05-31",
    "billing month": "2025-05",
    "totalSpend": "49,000",
    "premiumComposition": "73.00%",
    "premiumSpend": "35,770",
    "advancedSpend": "13,230",
    "premiumCPM": 18,
    "advancedCPM": 21,
    "premiumImps": "1,987,222",
    "advancedImps": "630,000",
    "premiumPercentage": "20.00%",
    "advancedPercentage": "17.65%",
    "premiumFee": "11,923",
    "advancedFee": "4,410",
    "totalFee": "16,334",
    "totalPercentage": "33.33%",
    "clientPercentage": "33.34%",
    "valueAfterFee": "33.33%",
    "statementNumber": "BIG-200264",
    "invoiceNumber": "BIG-91278299",
    "impIncreased": "",
    "country": "NZ"
  },
  {
    "Index": 90,
    "commercialModel": "unified - rewards",
    "start period": "2025-06-01",
    "end period": "2025-06-30",
    "billing month": "2025-06",
    "totalSpend": "58,000",
    "premiumComposition": "78.00%",
    "premiumSpend": "45,240",
    "advancedSpend": "12,760",
    "premiumCPM": 18,
    "advancedCPM": 21,
    "premiumImps": "2,513,333",
    "advancedImps": "607,619",
    "premiumPercentage": "20.00%",
    "advancedPercentage": "17.65%",
    "premiumFee": "15,080",
    "advancedFee": "4,254",
    "totalFee": "19,334",
    "totalPercentage": "33.33%",
    "clientPercentage": "33.34%",
    "valueAfterFee": "33.33%",
    "statementNumber": "BIG-200265",
    "invoiceNumber": "BIG-91278300",
    "impIncreased": "",
    "country": "NZ"
  },
  {
    "Index": 91,
    "commercialModel": "unified - rewards",
    "start period": "2025-07-01",
    "end period": "2025-07-31",
    "billing month": "2025-07",
    "totalSpend": "26,000",
    "premiumComposition": "66.00%",
    "premiumSpend": "17,160",
    "advancedSpend": "8,840",
    "premiumCPM": 18,
    "advancedCPM": 21,
    "premiumImps": "953,333",
    "advancedImps": "420,952",
    "premiumPercentage": "16.67%",
    "advancedPercentage": "14.71%",
    "premiumFee": "5,244",
    "advancedFee": "2,736",
    "totalFee": "7,980",
    "totalPercentage": "30.56%",
    "clientPercentage": "30.96%",
    "valueAfterFee": "30.69%",
    "statementNumber": "BIG-200266",
    "invoiceNumber": "BIG-91278301",
    "impIncreased": "",
    "country": "NZ"
  },
  {
    "Index": 92,
    "commercialModel": "unified - rewards",
    "start period": "2025-08-01",
    "end period": "2025-08-31",
    "billing month": "2025-08",
    "totalSpend": "22,000",
    "premiumComposition": "44.00%",
    "premiumSpend": "9,680",
    "advancedSpend": "12,320",
    "premiumCPM": 18,
    "advancedCPM": 21,
    "premiumImps": "537,778",
    "advancedImps": "586,667",
    "premiumPercentage": "16.67%",
    "advancedPercentage": "14.71%",
    "premiumFee": "2,958",
    "advancedFee": "3,814",
    "totalFee": "6,772",
    "totalPercentage": "30.56%",
    "clientPercentage": "30.96%",
    "valueAfterFee": "30.78%",
    "statementNumber": "BIG-200267",
    "invoiceNumber": "BIG-91278302",
    "impIncreased": "",
    "country": "NZ"
  },
  {
    "Index": 93,
    "commercialModel": "unified - rewards",
    "start period": "2025-09-01",
    "end period": "2025-09-30",
    "billing month": "2025-09",
    "totalSpend": "37,000",
    "premiumComposition": "49.00%",
    "premiumSpend": "18,130",
    "advancedSpend": "18,870",
    "premiumCPM": 18,
    "advancedCPM": 21,
    "premiumImps": "1,007,222",
    "advancedImps": "898,571",
    "premiumPercentage": "16.67%",
    "advancedPercentage": "14.71%",
    "premiumFee": "5,540",
    "advancedFee": "5,841",
    "totalFee": "11,382",
    "totalPercentage": "30.56%",
    "clientPercentage": "30.96%",
    "valueAfterFee": "30.76%",
    "statementNumber": "BIG-200268",
    "invoiceNumber": "BIG-91278303",
    "impIncreased": "",
    "country": "NZ"
  },
  {
    "Index": 94,
    "commercialModel": "unified - rewards",
    "start period": "2025-10-01",
    "end period": "2025-10-31",
    "billing month": "2025-10",
    "totalSpend": "31,000",
    "premiumComposition": "47.00%",
    "premiumSpend": "14,570",
    "advancedSpend": "16,430",
    "premiumCPM": 18,
    "advancedCPM": 21,
    "premiumImps": "809,444",
    "advancedImps": "782,381",
    "premiumPercentage": "16.67%",
    "advancedPercentage": "14.71%",
    "premiumFee": "4,452",
    "advancedFee": "5,086",
    "totalFee": "9,538",
    "totalPercentage": "30.56%",
    "clientPercentage": "30.96%",
    "valueAfterFee": "30.77%",
    "statementNumber": "BIG-200269",
    "invoiceNumber": "BIG-91278304",
    "impIncreased": "",
    "country": "NZ"
  },
  {
    "Index": 95,
    "commercialModel": "unified - rewards",
    "start period": "2025-11-01",
    "end period": "2025-11-30",
    "billing month": "2025-11",
    "totalSpend": "65,000",
    "premiumComposition": "50.00%",
    "premiumSpend": "32,500",
    "advancedSpend": "32,500",
    "premiumCPM": 18,
    "advancedCPM": 21,
    "premiumImps": "1,805,556",
    "advancedImps": "1,547,619",
    "premiumPercentage": "23.33%",
    "advancedPercentage": "20.59%",
    "premiumFee": "11,735",
    "advancedFee": "11,608",
    "totalFee": "23,343",
    "totalPercentage": "36.11%",
    "clientPercentage": "35.72%",
    "valueAfterFee": "35.91%",
    "statementNumber": "BIG-200270",
    "invoiceNumber": "BIG-91278305",
    "impIncreased": "",
    "country": "NZ"
  },
  {
    "Index": 96,
    "commercialModel": "unified - rewards",
    "start period": "2025-12-01",
    "end period": "2025-12-31",
    "billing month": "2025-12",
    "totalSpend": "28,000",
    "premiumComposition": "49.00%",
    "premiumSpend": "13,720",
    "advancedSpend": "14,280",
    "premiumCPM": 18,
    "advancedCPM": 21,
    "premiumImps": "762,222",
    "advancedImps": "680,000",
    "premiumPercentage": "16.67%",
    "advancedPercentage": "14.71%",
    "premiumFee": "4,193",
    "advancedFee": "4,420",
    "totalFee": "8,613",
    "totalPercentage": "30.56%",
    "clientPercentage": "30.96%",
    "valueAfterFee": "30.76%",
    "statementNumber": "BIG-200271",
    "invoiceNumber": "BIG-91278306",
    "impIncreased": "",
    "country": "NZ"
  }
]

